export default {
    elevation: 'elevation',
    terrace: 'terrace',
    stair: 'stair'
}
